import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=44e911cc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e911cc')) {
      api.createRecord('44e911cc', component.options)
    } else {
      api.reload('44e911cc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=44e911cc&", function () {
      api.rerender('44e911cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4h3u5z1Z3gd7G/JS/comp/ImgFallback.vue"
export default component.exports